// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"928":"deb9561c","964":"68169bda"}[chunkId] + ".chunk.css";
};